<template>
    <multi-page-item-settings
        items-array-name="accommodations"
        :settings="form"
        :item-creator-function="createEmptyItem"
        :default-close-handler="defaultCloseHandler"
    >
        <template slot-scope="{ edit, save, close, create, restore, selectedItem }">
            <wall-accommodations-block-general-settings
                key="general-settings"
                :form="form"
                @edit-item="edit"
                @create-item="create"
            ></wall-accommodations-block-general-settings>

            <wall-accommodations-block-item-settings
                key="item-settings"
                :event="event"
                :block="block"
                :item="selectedItem"
                @save-settings="save"
                @cancel="restore"
            ></wall-accommodations-block-item-settings>
        </template>
    </multi-page-item-settings>
</template>

<script>
import BlockableSettingsMixin from '@/mixins/BlockableSettingsMixin';
import HasDefaultCloseHandler from '@/mixins/HasDefaultCloseHandler';

export default {
    name: 'WallAccommodationsBlockSettings',

    mixins: [HasDefaultCloseHandler, BlockableSettingsMixin],

    methods: {
        createEmptyItem () {
            return {
                name: '',
                description: '',
                images: [],
                active: true,
                new: true,
                includeUrl: false,
                url: '',
                buttonText: '',
                address: null,
                viewOnMap: false,
                deletable: true
            };
        }
    }
};
</script>
